import React from "react";
import type { BonusTone } from "../data/landing";
import { BONUS_COVERS } from "../data/visuals";
type BonusCoverProps = {
  number: string;
  title: string;
  tone: BonusTone;
};
export function BonusCover({
  number,
  title
}: BonusCoverProps) {
  return <img className="real-bonus-cover" src={BONUS_COVERS[Number(number) - 1]} alt={`${title} cover`} width={1024} height={1024} loading="lazy" decoding="async" data-id="element-1" data-mp="3d38wz9nwt7yq" />;
}